module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-overview-tabs"
  }, [(_vm.tabs.length > 1) ? _c('div', {
    staticClass: "user-overview-tabs__tabs no-print"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "selected": _vm.activeView,
      "isLarge": true
    },
    on: {
      "select": function($event) {
        _vm.theView = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeView === 'tasks') ? _c('TaskOverviewPage', {
    attrs: {
      "user_id": _vm.user.id,
      "user_calendar_id": _vm.user.user_calendar_id,
      "user_name": _vm.user.name,
      "isCanSeeOtherUsers": false
    }
  }) : _c('UserTasks', {
    attrs: {
      "user_id": _vm.user.id,
      "user_calendar_id": _vm.user.user_calendar_id,
      "user_name": _vm.user.name,
      "initialStartDate": _vm.initialStartDate,
      "initialEndDate": _vm.initialEndDate,
      "initialIsShowScheduled": _vm.initialIsShowScheduled,
      "isShowPrintButton": true,
      "isCanSeeOtherUsers": false
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-549ddf9f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserOverviewTabs.vue
// module id = 1923
// module chunks = 1